import { render, staticRenderFns } from "./RemoveTypologySize.vue?vue&type=template&id=59fea046&scoped=true&"
import script from "./RemoveTypologySize.vue?vue&type=script&lang=js&"
export * from "./RemoveTypologySize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59fea046",
  null
  
)

export default component.exports